// extracted by mini-css-extract-plugin
export default {"button":"_2r_RXhSk_cYCw8VAL5rO5H","bold":"_3UdbcgfvfxEOuSB6JQY7wa"};